export const apiAccessConstants = {
    API_KEYS_LOADING_SPINNER: 'API_KEYS_LOADING_SPINNER',
    API_KEYS_FETCH: 'API_KEYS_FETCH',
    API_KEYS_REVOKE: 'API_KEYS_REVOKE',
    API_KEYS_RELOAD: 'API_KEYS_RELOAD',
};